/* eslint-disable max-len */
import "./Artist.scss";
import React, { useEffect, useState } from "react";
import { HEADER_TYPE, useHeader } from "providers/header-provider";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { bemElement } from "../../utils/bem-class-names";
import { handleGoBack } from "utils/handleGoBack";
import { Avatar } from "../../elements/avatar/Avatar";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import { IconButton } from "../../elements/icon-button/IconButton";
import { COLORS } from "../../models/colors";
import { SvgIcon } from "../../elements/svg-icon/svg-icon";
import { Button } from "../../elements/button/Button";
import { VARIANTS } from "../../models/variants";
import useResponsive from "../../hooks/useResponsive";
import ExpandableText from "../../components/expandable-text/ExpandableText";
import { IReview } from "../../components/review/Review";
import ReviewModal from "../../components/modals/review-modal/ReviewModal";
import { joinClassNames } from "../../utils/join-class-names";
import { useAxios } from "../../providers/axios";
import {
  useAddArtistToFavoriteMutation,
  useArtistQuery,
  useRemoveArtistFromFavoriteMutation
} from "./Artist.generated";
import { useUser } from "../../providers/user";
import { useHeaderTransparent } from "components/header/Header";
import { IconTitle } from "components/header/sections/icon-title/icon-title";
import { TLocation } from "../../types";

const baseClassName = "artist-page";
const bem = bemElement(baseClassName);

const reviewsMock = [
  {
    id: "asdad2-fg32f23-sdf3-f32f",
    user_name: "Rebeca",
    user_photo_url:
      "https://img.freepik.com/free-photo/young-and-beautiful-woman-in-pink-warm-sweater-natural-look-smiling-portrait-on-isolated-long-hair_285396-896.jpg",
    date: new Date().setFullYear(2022, 12, 15),
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae."
  },
  {
    id: "asdad2-fg32f23-sdf3-f32f1",
    user_name: "Rebeca",
    user_photo_url:
      "https://img.freepik.com/free-photo/young-and-beautiful-woman-in-pink-warm-sweater-natural-look-smiling-portrait-on-isolated-long-hair_285396-896.jpg",
    date: new Date().setFullYear(2022, 12, 15),
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae.Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae.Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae.Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae.Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae.Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae."
  },
  {
    id: "asdad2-fg32f23-sdf3-f32f2",
    user_name: "Rebeca",
    user_photo_url:
      "https://img.freepik.com/free-photo/young-and-beautiful-woman-in-pink-warm-sweater-natural-look-smiling-portrait-on-isolated-long-hair_285396-896.jpg",
    date: new Date().setFullYear(2022, 12, 15),
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae."
  },
  {
    id: "asdad2-fg32f23-sdf3-f32f3",
    user_name: "Rebeca",
    user_photo_url:
      "https://img.freepik.com/free-photo/young-and-beautiful-woman-in-pink-warm-sweater-natural-look-smiling-portrait-on-isolated-long-hair_285396-896.jpg",
    date: new Date().setFullYear(2022, 12, 15),
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae."
  },
  {
    id: "asdad2-fg32f23-sdf3-f32f4",
    user_name: "Rebeca",
    user_photo_url:
      "https://img.freepik.com/free-photo/young-and-beautiful-woman-in-pink-warm-sweater-natural-look-smiling-portrait-on-isolated-long-hair_285396-896.jpg",
    date: new Date().setFullYear(2022, 12, 15),
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae."
  },
  {
    id: "asdad2-fg32f23-sdf3-f32f5",
    user_name: "Rebeca",
    user_photo_url:
      "https://img.freepik.com/free-photo/young-and-beautiful-woman-in-pink-warm-sweater-natural-look-smiling-portrait-on-isolated-long-hair_285396-896.jpg",
    date: new Date().setFullYear(2022, 12, 15),
    rating: 4.8,
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis dolorem ducimus eos exercitationem facilis harum, illo impedit officia quibusdam quo quos tempore tenetur. Cupiditate earum eligendi error obcaecati, possimus quae."
  }
];

const Artist = (): JSX.Element | null => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { axios, api } = useAxios();
  const { setData } = useHeader();
  const { user, isLoggedIn } = useUser();
  const isHeaderTransparent = useHeaderTransparent();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [locationInfo, setLocationInfo] = useState<TLocation>();
  const [instagramPhotos, setInstagramPhotos] =
    useState<{ id: string; media_url: string }[]>();
  const [instagramUsername, setInstagramUsername] = useState<string>("");
  /* eslint-disable @typescript-eslint/no-unused-vars */
  const [reviews, setReviews] = useState<any[]>();
  /* eslint-disable @typescript-eslint/no-unused-vars */
  const [possibleAppointments, setPossibleAppointments] = useState<any[]>();
  const [showReviewModalData, setShowReviewModalData] =
    useState<IReview | null>(null);
  const [showReviewModal, setShowReviewModal] = useState<boolean>(false);
  const { isMobile, isDesktop, isXS } = useResponsive();

  const { data, refetch } = useArtistQuery({
    variables: {
      where: {
        id: params.id
      }
    },
    skip: !params.id
  });
  const artist = data?.artist;
  const [addArtistToFavorite] = useAddArtistToFavoriteMutation({
    variables: {
      data: {
        artist: {
          connect: {
            id: artist?.id
          }
        },
        user: {
          connect: {
            id: user?.id
          }
        }
      }
    }
  });
  const [removeArtistFromFavorite] = useRemoveArtistFromFavoriteMutation();

  const onHeartClick = async () => {
    if (isLoggedIn) {
      if (artist?.favourited_by.length === 0) {
        await addArtistToFavorite();
      } else {
        await removeArtistFromFavorite({
          variables: {
            where: {
              id: artist?.favourited_by[0]?.id
            }
          }
        });
      }
      refetch();
    }
  };

  useEffect(() => {
    setData({
      type: HEADER_TYPE.TYPE_1,
      leftSection: isDesktop ? null : (
        <IconButton
          color={COLORS.SECONDARY_CONTAINER}
          variant={
            isXS && isHeaderTransparent ? VARIANTS.FILLED : VARIANTS.DEFAULT
          }
          iconName="arrow_left"
          onClick={() => handleGoBack(navigate)}
        />
      ),
      rightSection: isDesktop ? null : isLoggedIn ? (
        <IconButton
          color={COLORS.SECONDARY_CONTAINER}
          variant={
            isXS && isHeaderTransparent ? VARIANTS.FILLED : VARIANTS.DEFAULT
          }
          iconName={
            artist?.favourited_by.length === 0 ? "heart" : "filled_heart"
          }
          onClick={onHeartClick}
          cyId={"favorite-artist-button-mobile"}
        />
      ) : null,
      centerSection: isDesktop ? null : isXS && isHeaderTransparent ? (
        <></>
      ) : (
        <IconTitle
          title={artist?.user?.first_name || ""}
          src={artist?.user?.photo_url || ""}
        />
      )
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [artist, isDesktop, isXS, isHeaderTransparent]);

  useEffect(() => {
    setReviews(reviewsMock);
  }, []);

  useEffect(() => {
    if (artist?.id) {
      api
        .get(`/v1/possible-appointments/artists/${artist.id}`, {
          params: {
            limit: 5
          }
        })
        .then((response) => {
          if (response.data.length > 0) {
            setPossibleAppointments(response.data[0]?.appointments);
            setLocationInfo(response.data[0].location);
          }
        })
        .catch(() => {
          setPossibleAppointments([]);
        });
    }
    if (artist?.artist_instagram) {
      axios
        .get(
          `https://graph.instagram.com/${artist.artist_instagram.instagram_user_id}/media?fields=id,media_type,media_url,username&access_token=${artist.artist_instagram.access_token}`
        )
        .then((response) => {
          if (response.data?.data?.length > 0) {
            setInstagramPhotos(
              response.data.data
                .filter((item: any) => item.media_type === "IMAGE")
                .map((item: any) => ({
                  id: item.id,
                  media_url: item.media_url
                }))
            );
            setInstagramUsername(response.data.data[0].username);
          }
        });
    }
  }, [api, artist, axios]);

  if (!artist) {
    return null;
  }

  return (
    <>
      <Helmet>
        <title>Pointment | {artist.user?.first_name}</title>
        <meta
          property="og:title"
          content={`Pointment | ${artist.user?.first_name}`}
        />
      </Helmet>
      <div className={baseClassName}>
        <div className={bem("container")}>
          <div className={bem("header")}>
            <div>
              {isDesktop && (
                <Breadcrumbs
                  breadcrumbs={[{ title: "Artist", url: location.pathname }]}
                />
              )}
            </div>
            <div className={bem("photos")}>
              <Avatar
                src={artist?.cover_photo_url || artist.user?.photo_url || ""}
                monogram={artist.user?.first_name || ""}
                size="xl"
                className={bem("artist-avatar")}
              />
            </div>
            <div>
              {isDesktop && isLoggedIn && (
                <IconButton
                  color={COLORS.SECONDARY_CONTAINER}
                  variant={VARIANTS.FILLED}
                  iconName={
                    artist.favourited_by.length === 0 ? "heart" : "filled_heart"
                  }
                  className={bem("heart-button")}
                  onClick={onHeartClick}
                  cyId="favorite-artist-button-desktop"
                />
              )}
            </div>
          </div>
          <div className={bem("info")}>
            <h3 className={bem("name")}>{artist.user?.first_name}</h3>
            {/* POI-1180 - Temporarily hiding this code with a comment. We will need it again very soon. */}
            {/* {possibleAppointments ? (
              <div className={bem("slots flex-wrap justify-center")}>
                {possibleAppointments.map((slot: any) => (
                  <SuggestionChip
                    key={slot.start_time}
                    type="low-alternative"
                    value={getTime(slot.start_time)}
                  />
                ))}
              </div>
            ) : (
              <div className={bem("slots")}>
                {Array(5)
                  .fill(1)
                  .map((slot: any, i: number) => (
                    <SuggestionChip key={i} type="low-alternative" value="" />
                  ))}
              </div>
            )} */}
            {artist.bio && (
              <>
                <ExpandableText
                  text={artist.bio}
                  limit={3}
                  className={bem("bio")}
                />
                {isMobile && <hr />}
              </>
            )}
            {/* POI-1180 - Temporarily hiding this code with a comment. We will need it again very soon. */}
            {/* {isDesktop && (
              <Button
                color={COLORS.SECONDARY}
                variant={VARIANTS.FILLED}
                text="Book a Pointment"
                size="lg"
                iconRightName="arrow_right"
                onClick={() =>
                  navigate(
                    `/company/${artist?.user?.joined_company?.slug}/location/${locationInfo.slug}?artist=${artist?.id}`
                  )
                }
              />
            )} */}
          </div>
          {instagramPhotos && instagramPhotos.length > 0 && (
            <div className={bem("insta-photos")}>
              <div className={bem("insta-photos-header")}>
                <div className={bem("insta-photos-header-left-side")}>
                  <SvgIcon name="other_instagram" />
                  <h4 className={bem("insta-photos-header-title")}>
                    Insta photos
                  </h4>
                </div>
                <Button
                  color={COLORS.PRIMARY}
                  text="Visit Instagram"
                  size="sm"
                  className={bem("insta-photos-header-button")}
                  onClick={() =>
                    instagramUsername &&
                    window.open(
                      `https://www.instagram.com/${instagramUsername}`
                    )
                  }
                />
              </div>
              <div
                className={joinClassNames(
                  bem("insta-photos-content"),
                  "hide-scroll-bar"
                )}
              >
                {instagramPhotos
                  .slice(0, isDesktop ? 6 : instagramPhotos.length)
                  .map((photo) => (
                    <img
                      key={photo.id}
                      src={photo.media_url}
                      alt=""
                      className={bem("insta-photos-content-photo")}
                    />
                  ))}
              </div>
            </div>
          )}
        </div>
        {/* POI-1180 - Temporarily hiding this code with a comment. We will need it again very soon. */}
        {/* {isMobile && (
          <div className={bem("book-button-mobile-wrapper")}>
            <Button
              color={COLORS.SECONDARY}
              variant={VARIANTS.FILLED}
              text="Book a Pointment"
              size="lg"
              iconRightName="arrow_right"
              className={`flexible ${bem("book-button-mobile")}`}
              onClick={() =>
                navigate(
                  `/company/${artist?.user?.joined_company?.slug}/location/${locationInfo.slug}?artist=${artist?.id}`
                )
              }
            />
          </div>
        )} */}
      </div>
      <ReviewModal
        value={showReviewModalData}
        show={showReviewModal}
        onHide={() => setShowReviewModal(false)}
      />
    </>
  );
};

export default Artist;
